<ng-container *ngFor="let nivel of Niveles; let i = index">
  <ion-list mode="ios" lines="none" class="ion-no-margin separator">
    <ion-item-group>
      <!-- Muestra la disponibilidad del nivel -->
      <ion-item
        lines="none"
        mode="md"
        [disabled]="level !== i && nivel.Minimo < 1"
        class="level-header"
      >
        <!-- Nivel actual -->
        <ion-note
          slot="start"
          color="darkblue"
          mode="md"
          class="note-level ion-align-self-center"
        >
          <ion-text color="darkblue" class="font-weight-600 max-min">
            {{ nivel.Nivel }}
          </ion-text>
        </ion-note>

        <!-- Estatus sin agregar productos en el nivel -->
        <ng-container *ngIf="level === i">
          <ion-label
            color="grayDemon"
            class="choose-box-options"
            [innerHtml]="
              'Labels.choose-box-options' | translate : nivel | htmlSeguro
            "
          >
          </ion-label>

          <!-- Produtos usados del nivel -->
          <ion-note
            slot="end"
            color="status-icon-enable"
            mode="md"
            class="ion-text-center status-select"
          >
            <!-- Retorna el canje del nivel -->
            <ion-text color="tpcta" class="font-weight-600 max-min">
              {{
                (refNiveles | filterArray : nivel.Nivel : 'Nivel')[0].Minimo ||
                  0
              }}
            </ion-text>

            <ion-text color="status-select" class="font-weight-600 max-min">
              {{ 'Labels.the' | translate }}
              {{ nivel.Maximo }}
            </ion-text>

            <ion-text color="grayDemon" class="box-es">
              {{ 'Labels.box-es' | translate }}
            </ion-text>
          </ion-note>
        </ng-container>

        <!-- Estatus en espera de nivel -->
        <ng-container *ngIf="level !== i && nivel.Minimo < 1">
          <ion-label color="grayDemon" class="choose-box-options">
            {{ 'Labels.add-necessary-products-previous-level' | translate }}
          </ion-label>
        </ng-container>

        <!-- Estatus de nivel anterior -->
        <ng-container *ngIf="level !== i && nivel.Minimo > 0">
          <ion-label
            color="grayDemon"
            class="choose-box-options"
            [innerHtml]="
              'Labels.you-added-box-es' | translate : nivel | htmlSeguro
            "
          >
          </ion-label>

          <!-- Boton editar -->
          <ion-button
            slot="end"
            mode="md"
            color="white"
            size="default"
            (click)="onEdit(i)"
            [disabled]="disabledEdit || validLevelEdit()"
            class="button-edit"
          >
            <ion-label color="status-icon-enable">
              {{ 'Buttons.edit' | translate }}
            </ion-label>
          </ion-button>
        </ng-container>
      </ion-item>
    </ion-item-group>

    <ion-item-group [ngClass]="level === i ? 'active' : 'inactive'">
      <!-- Lista de los prductos del nivel -->
      <ng-container
        *ngFor="
          let product of productosPromocion
            | filterArray : nivel.Nivel : 'Nivel';
          let j = index
        "
      >
        <row-product
          [product]="product"
          [clase]="
            j + 1 <
            (productosPromocion | filterArray : nivel.Nivel : 'Nivel').length
              ? 'separator-dashed'
              : 'separator'
          "
          [rangeSelector]="true"
          [productsUsesReference]="
            (cartPromoProducts
              | filterArray : product.id_producto : 'id_producto'
              | filterArray : product.Nivel : 'Nivel')[0].productos
          "
          [maxRange]="
            nivel.Maximo -
            (refNiveles | filterArray : nivel.Nivel : 'Nivel')[0].Minimo
          "
          (productUse)="productUse($event, nivel.Nivel)"
        ></row-product>
      </ng-container>

      <!-- Botton siguiente -->
      <ion-item lines="none" mode="md">
        <ion-button
          expand="full"
          mode="md"
          color="tpcta"
          size="default"
          class="button-next"
          [disabled]="disabledNextStates[nivel.Nivel]"
          (click)="onNext(validLevels() ? i : Niveles.length - 1)"
        >
          <ion-label md="md" color="white">
            {{ 'Buttons.next' | translate }}
          </ion-label>
          <ion-icon
            name="chevron-forward-outline"
            slot="end"
            color="white"
          ></ion-icon>
        </ion-button>
      </ion-item>
    </ion-item-group>
  </ion-list>
</ng-container>

<!-- El ultimo nivel es canje de promo -->
<ion-list mode="ios" lines="none" class="ion-no-margin separator">
  <ion-item
    lines="none"
    mode="md"
    [disabled]="validLevels()"
    class="level-header"
  >
    <!-- Nivel actual -->
    <ion-note
      slot="start"
      color="darkblue"
      mode="md"
      class="note-level ion-align-self-center"
    >
      <ion-text color="darkblue" class="font-weight-600 max-min">
        {{ Niveles.length + 1 }}
      </ion-text>
    </ion-note>

    <ion-label color="grayDemon" class="choose-box-options">
      {{
        'Labels.' + (isBonus ? 'bonuses-to-redeem' : 'promotions-to-redeem')
          | translate
      }}
    </ion-label>
  </ion-item>
</ion-list>
